import jonasProfile from '@/assets/images/jonas.jpg';
import jonasHeader from '@/assets/images/profile-header.jpg';
import axelProfile from '@/assets/images/axel.jpg';
import sarahProfile from '@/assets/images/profile2.jpg';

export default [
  {
    username: 'jonaskuske',
    name: 'Jonas Kuske',
    profilePicture: jonasProfile,
    headerImage: jonasHeader,
  },
  {
    username: 'matthiaswengel',
    name: 'Matthias Wengelmann',
  },
  {
    username: 'sarahtau',
    name: 'Sarah Taulich',
    profilePicture: sarahProfile,
  },
  {
    username: 'axelschmaxel',
    name: 'Axel Schmaxel',
    profilePicture: axelProfile,
  },
  {
    username: 'tomlöhner',
    name: 'Tom Löhner',
  },
  {
    username: 'maraschmidt',
    name: 'Mara Schmidt',
  },
];
